// ./src/config/auth0.js

const host = `https://${location.host}`

export default {
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,
  redirect: process.env.VUE_APP_AUTH0_REDIRECT_URL || host
}
